import { css } from 'emotion';

const transitions = timeout => {
    return {
        entering: css``,
        entered: css``,
        exiting: css``,
    };
};

const getTransition = ({ timeout, status }) => transitions(timeout)[status];

export default getTransition;



// WEBPACK FOOTER //
// ./src/css/transitions.js